module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAACgCAYAAAAb8NynAAAAqElEQVR42u3WMQrCMBSA4c4exUvp0byEk4MXKE5N2ot01ggKUhQKpnnL90HW/vBIk3QdAAAA/GUYhv04jreU0rVZtASPOed5mqb7c20e7Pt+V6Knd7BJ+DXatIxuGl6OdvPwr9HWXOX759Wjrb1Wj7Z6uMVov4ZL9NI6GhsOG/XH5jo03Vzhv1PoARJ6ZIZfEqHXYuhDIPzpAwAAAAAAAAAAAAAAADT2AN/Xk1C5tqC4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/step-arrow.png
// module id = 10
// module chunks = 1